import { PageState } from '../../../core/page/page.types';
import { AdminVendorModel } from '../vendor_types';

// PAGE
export type PageInit = string; // return page title on init (its NEVER set again)
export type PageMode = '' | 'UPDATE' | 'CREATE';
export type PageStoreHook<TPageState extends PageState> = {
    state: TPageState;
    setEditStatus: (edit: boolean) => void;
    cancelEdit: () => void;
    setPageMode: (mode: PageMode, id: string, isTPA?: boolean) => void;
    waiting: boolean;
    setWait: (wait: boolean) => void;
};

// EDIT FORM
export type StatusVal = '' | 'ACTIVE' | 'INACTIVE';

export type EditStateVendor = {
    init: boolean;
    waiting: boolean;
    excludedVINs: string[];
};

export type EditStateHook = EditStateVendor & {
    setWait: (wait: boolean) => void;
};
export type EditModelHook = {
    model: AdminVendorModel;
    setPropText: (prop: string, val: string) => void;
    setStatus: (status: StatusVal) => void;
    submit: () => boolean;
};

export type VendorEditPageState = PageState & {
    title: string;
    isVeritySA: boolean;
    mode: PageMode;
    id: string;
    waiting: boolean;
    isTPA: boolean;
};

export enum VendorType {
    WHOLESALER = 'WHOLESALER',
    MANUFACTURER = 'MANUFACTURER',
    PBM = 'PBM',
    TPA = 'TPA',
}
